import { useTranslation } from "react-i18next";
import { InfoDanger } from "../../assets/svgs";
import { getCountryFlag } from "../../utils/svgUtils";
import "./styles.scss";
import { useLocation } from "react-router-dom";

const allowedChars = /^\d+$/;

const keyCodes = [9, 37, 39, 17, 86];

const PhoneNumberInput = ({
  value,
  onChange,
  name,
  countryCode,
  maxLength,
  isoCode = "SAU",
  error,
  onBlur,
  ContainerStyle,
  isInvalid,
  isRequired,
  label,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];
  const Flag = getCountryFlag(isoCode);

  const handleOnChange = (event) => {
    event.target.value = event.target.value.replace(/[^0-9]/g, "");
    onChange({
      target: {
        name,
        value: event.target.value,
      },
    });
  };

  const handleKeyDown = (event) => {
    if (
      !allowedChars.test(event.key) &&
      event.keyCode !== 8 &&
      !keyCodes.includes(event.keyCode)
    ) {
      event.preventDefault();
    }
  };

  return (
    <div
      className="phone-number-wrapper"
      style={!isInvalid ? { marginBottom: 21 } : undefined}
    >
      <div className="phone-number-container" style={ContainerStyle}>
        <div className="phone-label-container">
          <div className="flag-icon-container">
            <img src={Flag} alt="flag" className="flag-icon" />
          </div>
          <div>
            <label className="custom-label">
              {label}{" "}
              {isRequired && (
                <span className="is-required">
                  {t(routeName ? `${routeName}.required` : `app.required`)}
                </span>
              )}
            </label>
            <div className="number-input-container">
              <span className="prefix-text">{`(+${countryCode})`}</span>
              <input
                type="text"
                value={value}
                onChange={handleOnChange}
                name={name}
                className="number-input"
                maxLength={maxLength}
                onKeyDown={handleKeyDown}
                onBlur={onBlur}
              />
            </div>
          </div>
        </div>
      </div>
      {isInvalid && (
        <div className="error-container">
          <img src={InfoDanger} alt="info danger" />
          <span className="error-message">{error}</span>
        </div>
      )}
    </div>
  );
};

export default PhoneNumberInput;
